import ReportsAdminPage from './ReportsAdminPage';
export default ReportsAdminPage;
